export default __webpack_public_path__ + "static/pequenin-logo-pwa-4fe6331bbcd3210d3c28c3fdf5253257.png";